import CryptoJS from "crypto-js";
import { getBusinessKeys } from "../pages/Settings/settingsAPI";

export const encryptPayloadWithMerchantKeyJIT = async (
  businessId: number | string,
  payloadData: any
): Promise<{ encryptedMessage: string; publicKey: string }> => {
  if (!businessId) {
    throw new Error("businessId is required for merchant payload encryption.");
  }

  const res = await getBusinessKeys(businessId);
  const keys = res?.data || res;
  const encryptionKey = keys?.encryptionKey;
  const publicKey = keys?.publicKey;

  if (!encryptionKey) {
    throw new Error("Unable to retrieve merchant encryption key.");
  }

  const encryptedMessage = CryptoJS.AES.encrypt(
    JSON.stringify(payloadData),
    encryptionKey
  ).toString();

  return { encryptedMessage, publicKey };
};